export default __webpack_public_path__ + "static/media/help-center.6bceb6d0.svg";